import { Endpoints } from "@/api/ApiEndpoints";
import router from "@/router";
import { Paths } from "@/core/config/enums/SitePaths";
import { Inputs, validationSchema } from "@/entities/Tournaments/TournamentsFormInputs";

const Tournaments = {
  Plural: "Tournaments",
  Single: "Tournament",
  IsPage: true,
  FormWithImage: false,
  Inputs: Inputs,
  Relationships: [
    {
      name: "leagueId",
      endpoint: Endpoints.LEAGUES_FOR_FILTERS,
      mapping: (response: any) => response,
      dataMapping: (response) => {
        response.forEach((element) => {
          element["name"] = element.country.name + " - " + element.name;
        });
        return response;
      },
    },
    {
      name: "countryIds",
      endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
      mapping: (response: any) => response,
      dataMapping: (response) => response,
    },
    {
      name: "excludeCountryIds",
      endpoint: Endpoints.COUNTRIES_FOR_FILTERS,
      mapping: (response: any) => response,
      dataMapping: (response) => response,
    },
    {
      name: "sponsorId",
      endpoint: Endpoints.SPONSORS_ALL,
      mapping: (response: any) => response,
      dataMapping: (response: any) => response,
    },
  ],
  ValidationSchema: validationSchema,
  SaveCallBack: (id: number) => {
    router.push(Paths.TOURNAMENTS_EDIT.replace(":id", String(id)));
  },
};

export default Tournaments;
